import { FC } from 'react';
import CloudFrame from '../../../components/CloudFrame/CloudFrame';
import CloudFallback from '../../../components/CloudFrame/CloudFallback';

export const AccessAnalysisCloud: FC = () => (
    <div className="h-screen w-[calc(100vw-64px)] ml-16 bg-sf-white">
        <CloudFrame
            srcRoute={`/silverfort/v1/access-analysis`}
            fallback={<CloudFallback />}
            className="w-full h-full overflow-hidden"
        />
    </div>
);
